module.exports = __webpack_public_path__ + "static/media/insta-16.4dc6b951.png";